// extracted by mini-css-extract-plugin
export default {"bl-content-wrapper":"BLContentCardWrapper_bl-content-wrapper__u5MV4"};